import { render, staticRenderFns } from "./shoe-size.vue?vue&type=template&id=bd053e3c&scoped=true"
import script from "./shoe-size.vue?vue&type=script&lang=js"
export * from "./shoe-size.vue?vue&type=script&lang=js"
import style0 from "./shoe-size.vue?vue&type=style&index=0&id=bd053e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd053e3c",
  null
  
)

export default component.exports